module.exports = __webpack_public_path__ + "img/report-icon.fb19ae1a.svg";